/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StaffRequest } from './StaffRequest';
import {
    StaffRequestFromJSON,
    StaffRequestFromJSONTyped,
    StaffRequestToJSON,
    StaffRequestToJSONTyped,
} from './StaffRequest';

/**
 * 
 * @export
 * @interface StaffRequestResponse
 */
export interface StaffRequestResponse {
    /**
     * 
     */
    data: StaffRequest;
}

/**
 * Check if a given object implements the StaffRequestResponse interface.
 */
export function instanceOfStaffRequestResponse(value: object): value is StaffRequestResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function StaffRequestResponseFromJSON(json: any): StaffRequestResponse {
    return StaffRequestResponseFromJSONTyped(json, false);
}

export function StaffRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StaffRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': StaffRequestFromJSON(json['data']),
    };
}

export function StaffRequestResponseToJSON(json: any): StaffRequestResponse {
    return StaffRequestResponseToJSONTyped(json, false);
}

export function StaffRequestResponseToJSONTyped(value?: StaffRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': StaffRequestToJSON(value['data']),
    };
}

